import { readyHTMLForParse } from 'wsm-tagging-utils';

/**
 *
 * @param {string} str The HTML string to turn into an element.
 * @returns An HTMLElement for use in testing.
 */
const createElement = (str) => {
	const element = document.createElement('template');
	element.innerHTML = readyHTMLForParse(str);
	return element.content.firstChild;
};

export default createElement;
